export default __webpack_public_path__ + "images/freedial_logo.svg";